import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useIntl } from 'react-intl';
import SimpleDropdown from '~/modules/common/components/SimpleDropdown';
import { TASKS_TO_RESCHEDULE_TYPE } from './enum';

const labelId = 'tasks-to-reschedule-label';

const selectProps = {
  id: 'tasks-to-reschedule',
  labelId,
  SelectDisplayProps: {
    role: 'combobox'
  }
};

const inputLabelProps = {
  id: labelId
};

export const TasksToRescheduleDropDown = ({
  value,
  onChange,
  isPsaRmpTaskAllocation1Enabled,
  ...rest
}) => {
  const intl = useIntl();

  const options = Object.values(TASKS_TO_RESCHEDULE_TYPE).map(v => ({
    id: v,
    displayText: intl.formatMessage({
      id: `rescheduleProject.tasksToRescheduleType.${v}`
    })
  }));

  const selectedValue = useMemo(() => options.find(x => x.id === value), [
    options,
    value
  ]);

  return (
    <SimpleDropdown
      label={intl.formatMessage({
        id: `rescheduleProject.tasksToReschedule`
      })}
      options={options}
      onChange={onChange}
      value={selectedValue}
      noneOption={false}
      disableSort
      required
      selectProps={isPsaRmpTaskAllocation1Enabled ? selectProps : undefined}
      inputLabelProps={
        isPsaRmpTaskAllocation1Enabled ? inputLabelProps : undefined
      }
      {...rest}
    />
  );
};

TasksToRescheduleDropDown.propTypes = {
  value: PropTypes.oneOf([
    TASKS_TO_RESCHEDULE_TYPE.ALL_TASKS,
    TASKS_TO_RESCHEDULE_TYPE.IN_PROGRESS,
    TASKS_TO_RESCHEDULE_TYPE.NOT_STARTED
  ]),
  onChange: PropTypes.func.isRequired,
  isPsaRmpTaskAllocation1Enabled: PropTypes.bool.isRequired
};

export default TasksToRescheduleDropDown;
